import React from "react";
import logo from "icons/new-vt-docs-white.svg";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";

const LicenseSetupNavBar = () => {
  const productVersion = document
    .querySelector('meta[name="productVersion"]')
    .getAttribute("content");

  return (
    <div className="license_setup__nav_bar" data-testid="license-setup-navbar">
      <Button
        onClick={() => {}}
        variant={buttonVariants.borderless}
        content={<img src={logo} alt="Logo" />}
      />
      <span className="license_setup__nav_bar__product_version">
        {productVersion}
      </span>
      <span className="license_setup__nav_bar__page_title">Setup</span>
    </div>
  );
};

export default LicenseSetupNavBar;
